import LoginForm from "./Register";

export default LoginForm;
